export default __webpack_public_path__ + "static/blobofwax-bc7e2cd488ce95cdebe8dee160191733.png";